module.exports = __webpack_public_path__ + "static/media/plant_2.90a1fae3.png";